"use strict";

import BarHorizontalController from "./bar-horizontal.controller.js";

function barHorizontal(){

    return{
        restrict: "EA",
        scope: {
            name: "@",
            id: "@",
            chartIndex: '@',
            sortBy: '@',
            metricName: '@',
            metricValue: '@',
            maxValue: '@'
        },
        template: require("./bar-horizontal.html"),
        controller: BarHorizontalController,
        controllerAs: "ctrl",
        link:function(scope, elem, attrs){

            ///////CHART GOES HERE

            let chart;
            let xScale = d3.scale.linear();
            xScale.domain([0, parseInt(scope.maxValue)]);
            xScale.range([0, 100]);

            if (!chart) {
                chart = d3.select(elem[0])
                    .append('svg')
                    .attr({
                        'class': 'barChartHorizontalSimple',
                        'width': 100,
                        'height': 6
                    })
                    .append('g')
                    .attr({
                        'transform': 'translate(0,0)'
                    })


            var rectsBG = chart
                    .append('rect')
                    .attr({
                        'class': 'rectsBG'
                    })
                    .style('fill', function(){
                        return "#e5e5e5";
                    });

                rectsBG.transition()
                    .duration(500)
                    .ease('quad-in-out')
                    .attr({
                        'x':  function(){
                            return 0;
                        },
                        'y':  function(){
                            return 0;
                        },
                        'width':  function(){
                            return 100;
                        },
                        'height': 6
                    });



            var rects = chart
                .append('rect')
                .attr({
                    'class': 'rects'
                })
                .style('fill', function(){
                    return "#00AED9";
                });

            rects.transition()
                .duration(500)
                .ease('quad-in-out')
                .attr({
                    'x':  function(d){
                        return 0;
                    },
                    'y':  function(){
                        return 0;
                    },
                    'width':  function(){
                        return Math.abs(xScale(parseInt(scope.metricValue)) - xScale(0));
                    },
                    'height': 6
                });

            }


        }

    }

}

export default angular
    .module("bar-horizontal.directive", [])
    .directive("barHorizontal", barHorizontal)
    .name;




// WEBPACK FOOTER //
// ./src/app/emxd-charts/bar-horizontal/bar-horizontal.directive.js